module.exports = __webpack_public_path__ + "img/edfcf1e8892c70bce7c8b39675f2fe33.c23ea16b.jpg";